jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};

jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};

jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

var g_dev = true;

// window vars
var g_windowHeight = $(window).height();
var g_windowWidth = $(window).width();
$(window).resize(function () {
	g_windowHeight = $(window).height();
	g_windowWidth = $(window).width();
});

// scroll vars
var g_scroll = $(window).scrollTop();
$(window).scroll(function () {
	g_scroll = $(window).scrollTop();
});


// Set fixed header when not on this pages
if(
    !$('body').is('[class*="body_offer"]') &&
    !$('body').is('[class*="body_webshop"]') &&
    !$('body').hasClass('body_productgroup-webshop')
) {
    fixedHeader();
}

function fixedHeader() {
    var lastScrollTop = 0;

    $(window).scroll(function(e){
        // Add shadow
        if(g_scroll > 0) {
            $('.header-section').addClass('shadow');
        } else {
            $('.header-section').removeClass('shadow');
        }

        // Hide topmenu
        var st = $(this).scrollTop();
        if (st > lastScrollTop){
            $('.header-section').addClass('fixed');

            // Over ramenfabriek uitbreiden
            if(!$('.menu-item__windowfactory .menu-item__project').length) {
                $('.header-top-menu .menu-item__project').clone().appendTo($('.menu-item__windowfactory .sub-menu'));
                if(!$('.sub-items .menu-item__project .item').length) {
                    $('.sub-items .menu-item__project a span').wrap('<div class="item"></div>');
                }
            }
            if(!$('.menu-item__windowfactory .menu-item__professional').length) {
                $('.header-top-menu .menu-item__professional').clone().appendTo($('.menu-item__windowfactory .sub-menu'));
                if(!$('.sub-items .menu-item__professional .item').length) {
                    $('.sub-items .menu-item__professional a span').wrap('<div class="item"></div>');
                }
            }

            // Contact verplaatsen
            $('.menu-item__contact').insertAfter($('.menu-item__windowfactory'));
            if(!$('.menu-item__contact .toggle').length) {
                $('.menu-item__contact').addClass('sub-items');
                $('<span class="toggle toggle-sub-menu"><i class="icon icon-chevron-down"></i></span><ul class="sub-menu"></ul>').appendTo('.menu-item__contact')
                $('.header-info .menu-item__appointment').clone().appendTo($('.menu-item__contact .sub-menu'));
                if(!$('.menu-item__appointment .item').length) {
                    $('.sub-menu .menu-item__appointment a span').addClass('hide-no-submenu');
                    $('.sub-menu .menu-item__appointment a span').wrap('<div class="item"></div>');
                }
                $('.header-info .contact-whatsapp').clone().appendTo($('.menu-item__contact .sub-menu'));
                $('.header-info .contact-phone').clone().appendTo($('.menu-item__contact .sub-menu'));

                $('.header-info .socialmedia .social-facebook').clone().appendTo($('.menu-item__contact .sub-menu'));
            }
        } else {
            $('.header-section').removeClass('fixed');

            // Contact verplaatsen
            $('.menu-item__contact .toggle').remove();
            $('.menu-item__contact .sub-menu').remove();
            $('.menu-item__contact').removeClass('sub-items');
            $('.menu-item__contact').insertAfter($('.menu-item__appointment'));

            // Over ramenfabriek uitbreiden
            $('.menu-item__windowfactory .menu-item__project').remove();
            $('.menu-item__windowfactory .menu-item__professional').remove();
        }

        lastScrollTop = st;
    });
}


// Unsorted scripts
$(document).ready(function () {

    $('html').addClass('js-enabled');

    // Don't disable on local environment
    if(window.location.href != 'http://vagrant10/opthoog/') {
        $("img").on("contextmenu",function(){
            return false;
        });
    }

	// Selectize
	$('.selectize').selectize({
		create: false,
		sortField: 'text'
	});

	// Datepicker
	$('.datepicker').datepicker({
		dateFormat: 'dd-mm-yy'
	}, $.datepicker.regional['nl']);

	// Dismiss alert
	$(".alert .icon-cross, #site_alert .alert, .alert::after").on('click', function (e) {
		e.preventDefault();
		$(this).parent().remove();
	});

	// Tooltip
	$('.tooltip').tooltipster({
		theme: 'tooltipster-light',
		maxWidth: 250
	});

	// List-toggle
	$(".list-toggle li .label").on('click', function (e) {
		$(this).parent().siblings().removeClass("active");
		$(this).parent().toggleClass("active");
	});
	$(".list-toggle:first li:first-child .label").trigger('click');


	// Clickable
	$('.clickable').mousedown(function (e) {
		switch (e.which) {
			case 1:
				window.location = $(this).find("a").attr("href");
				return false;
			case 2:
				window.open($(this).find("a").attr("href"));
				break;
		}
	});

	// Social media share buttons
	$('.share').on('click', function (e) {
		e.preventDefault();
		var target = $(this).attr('href');
		window.open(target, 'popup', 'width = 500, height = 300');
	});

	// Autofocus
	$('.auto-focus:first').focus();

	// Scroll to element
	$(".scroll-to").click(function() {
		var scrollToElement = $(this).data("scroll");
		$('html, body').animate({
			scrollTop: $("."+scrollToElement).offset().top
		}, 300);
	});

});


// Slider
// Options for different Slider instances
$(document).ready(function () {
	$('.slider-profile.show-5').slick({
		autoplaySpeed: 5000,
		pauseOnHover: false,
		slidesToScroll: 1,
		draggable: true,
		autoplay: true,
		infinite: true,
		arrows: false,
		dots: false,
		speed: 500,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 3,
					dots: true
				}
			}, {
				breakpoint: 799,
				settings: {
					slidesToShow: 2,
					dots: true
				}
			}, {
				breakpoint: 599,
				settings: {
					slidesToShow: 1,
					dots: true
				}
			}
		]
	});
	$('.slider-profile.show-4').slick({
		autoplaySpeed: 5000,
		pauseOnHover: false,
		slidesToScroll: 1,
		draggable: true,
		autoplay: true,
		infinite: true,
		arrows: false,
		dots: false,
		speed: 500,
		slidesToShow: 4,
		responsive: [
			{
				breakpoint: 1199,
				settings: {
					slidesToShow: 3,
					dots: true
				}
			}, {
				breakpoint: 799,
				settings: {
					slidesToShow: 2,
					dots: true
				}
			}, {
				breakpoint: 599,
				settings: {
					slidesToShow: 1,
					dots: true
				}
			}
		]
	});
	$('.slider-profile.show-3').slick({
		autoplaySpeed: 5000,
		pauseOnHover: false,
		slidesToScroll: 1,
		draggable: true,
		autoplay: true,
		infinite: true,
		arrows: false,
		dots: false,
		speed: 500,
		slidesToShow: 3,
		responsive: [
			{
				breakpoint: 799,
				settings: {
					slidesToShow: 2,
					dots: true
				}
			}, {
				breakpoint: 599,
				settings: {
					slidesToShow: 1,
					dots: true
				}
			}
		]
	});
	$('.slider-profile.show-2').slick({
		autoplaySpeed: 5000,
		pauseOnHover: false,
		slidesToScroll: 1,
		draggable: true,
		autoplay: true,
		infinite: true,
		arrows: false,
		dots: false,
		speed: 500,
		slidesToShow: 2,
		responsive: [
			{
				breakpoint: 599,
				settings: {
					slidesToShow: 1,
					dots: true
				}
			}
		]
	});
	if ($('.slider').length > 0) {
		$('.slider').slick({
			dotsClass: 'slick-dots inside-dots',
            lazyLoad: 'ondemand',
            autoplaySpeed: 8000,
            pauseOnHover: false,
			slidesToScroll: 1,
			slidesToShow: 1,
			draggable: true,
			autoplay: true,
			infinite: true,
			arrows: true,
			dots: false,
			speed: 500
		});
	}

    if ($('.slider-usps').length > 0) {
        $('.slider-usps').slick({
            lazyLoad: 'ondemand',
            autoplaySpeed: 5000,
            pauseOnHover: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            centerMode: false,
            slidesToShow: 3,
            draggable: true,
            autoplay: true,
            infinite: true,
            arrows: false,
            dots: false,
            speed: 500,
            rows: 0,
            responsive: [{
                breakpoint: 500,
                settings: {
                    slidesToShow: 2
                }
            }]
        });
    }

	if ($('.usp-slider').length > 0) {
		$('.usp-slider').slick({
			dotsClass: 'slick-dots',
			autoplaySpeed: 5000,
			pauseOnHover: false,
			slidesToScroll: 1,
			slidesToShow: 4,
			draggable: true,
			autoplay: true,
			infinite: true,
			arrows: false,
			dots: true,
			speed: 800,
			responsive: [
				{
					breakpoint: 1199,
					settings: {
						slidesToShow: 3
					}
				}, {
					breakpoint: 799,
					settings: {
						slidesToShow: 2
					}
				}, {
					breakpoint: 599,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}

	if ($('.inspiration-slider').length > 0) {
		$('.inspiration-slider').slick({
			dotsClass: 'slick-dots inside-dots',
			autoplaySpeed: 5000,
			pauseOnHover: false,
			slidesToScroll: 1,
			centerMode: true,
			draggable: true,
			slidesToShow: 3,
			autoplay: false,
			infinite: true,
			arrows: true,
			dots: false,
			speed: 500,
			responsive: [
				{
					breakpoint: 1299,
					settings: {
						slidesToShow: 2
					}
				}, {
					breakpoint: 799,
					settings: {
						slidesToShow: 1
					}
				}
			]
		});
	}
});


// FancyBox
// Options for different Fancybox instances
$(document).ready(function () {
	var fboxOptions = {
		openEffect: 'none',
		closeEffect: 'none',
		openSpeed: 150,
		closeSpeed: 150,
		helpers: {
			overlay: {
				locked: false
			}
		}
	};

	$(".fancybox").fancybox(fboxOptions);
	$(".gallery li a").fancybox(fboxOptions);

	$(".fancybox[data-fancybox-type=ajax]").fancybox({
		parent: '.fancybox-ajax',
		closeEffect: 'none',
		scrolling: 'hidden',
        openEffect: 'none',
		autoCenter: true,
		padding: 0,
		helpers: {
			overlay: null
		},
		beforeLoad: function () {
			$('html').addClass("fancybox-locked");
		},
		afterClose: function () {
			$('html').removeClass("fancybox-locked");
		}
	});

	$(".fancybox[data-fancybox-type=iframe]").fancybox({
		parent: '.fancybox-ajax',
		closeEffect: 'none',
		scrolling: 'hidden',
		openEffect: 'none',
		width: '100%',
		padding: 0,
		margin: 0,
		helpers: {
			overlay: null
		},
		beforeLoad: function () {
			$('html').addClass("fancybox-locked");
		},
		afterClose: function () {
			$('html').removeClass("fancybox-locked");
		}
	});
});


// HashLink
// Scroll on click/Documentready
$(document).ready(function () {
	// HashLink Scroll on Click
	$('a[href^=#]').on('click', function (event) {
		if ($(this.hash).length > 0) {
			event.preventDefault();
			var fixedmenu = $('.header-section').height() + 10;
			if ($('.header-section').length > 0 && $('.header-section').hasClass('fixed')) {
				$('html,body').animate({scrollTop: $(this.hash).offset().top - fixedmenu}, 500);
			} else {
				$('html,body').animate({scrollTop: $(this.hash).offset().top}, 500);
			}
		}
	});
	// HashLink Scroll on Documentready
	if (window.location.hash) {
		var hash = window.location.hash.substring(1)
		if ($('#' + hash).length > 0) {
			var fixedmenu = $('.header-section').height();

			if ($('.header-section').length > 0 && $('.header-section').hasClass('fixed')) {
				$('html,body').animate({scrollTop: $('#' + hash).offset().top - fixedmenu}, 500);
			} else {
				$('html,body').animate({scrollTop: $('#' + hash).offset().top}, 500);
			}
		}
	}
});


// Searchbar
// Opens searchbar when clicked on the searchtoggle
$(document).ready(function () {
	searchBar();

	function searchBar() {
		$('.searchbar-toggle').on('click', function (e) {
			e.preventDefault();
			$('.searchbar-section').toggleClass('active');
			$('.searchbar-section input').val('').focus();
		});
	}
});


// OfferImages
// Move only the first offer image to sidebar on mobile
$(document).ready(function () {

	offerImage();
	$(window).resize(offerImage);

	function offerImage() {
		if (g_windowWidth<800) {
			if ($('.sidebar .fixed-element .offer-image-head').length > 0) {
				$('.offer-image-head').prependTo('.container-section .fixed-row .content');
			}
			if ($('.sidebar-info').length > 0) {
				$('.sidebar-info').prependTo('.js-mobile-sidebar');
			}


		} else {
			if ($('.container-section .fixed-row .content .offer-image-head').length > 0) {
				$('.offer-image-head').prependTo('.sidebar .fixed-element');
			}
		}
	}
});


// FixedSidebar
// Gives the sidebar a fixed class depending on multiple vars

function fixedSidebar(fixedHeight) {
	if ($('.fixed-element').length > 0) {
		sidebarParent = $(".fixed-element").parent();
		scrollParent = $(".fixed-row").outerHeight();
		contentHeight = Math.round($(".fixed-row .content").outerHeight());
		sidebarHeight = Math.round($(".fixed-element").outerHeight());

		// Disable fixed scrollbar on small screens AND when sidebar is larger than it's parent
		if (g_windowWidth >= 800 && sidebarHeight <= contentHeight) {

			// Copy width
			$(".fixed-element").width($(".fixed-row .sidebar").width());

			// Check if sidebar is larger than window height
			var scroll = Math.round(g_scroll);
			var offsetTop = Math.round($(sidebarParent).offset().top);
			var offsetBottom = Math.round(($(sidebarParent).parent().outerHeight() + $(sidebarParent).parent().offset().top) - sidebarHeight - 32);
			var fixedClass = "fixed";

			if (typeof fixedHeight === 'undefined') {
				var parentMax = Math.round($(sidebarParent).parent().outerHeight());
			} else {
				var parentMax = Math.round($(sidebarParent).parent().outerHeight()) - fixedHeight;
			}

			// check if scroll is larger than fixed offset
			if (scroll - offsetTop > 0) {
				var fixedPosition = scroll - offsetTop;
				var fixedPositionMax = fixedPosition + sidebarHeight;

				if (fixedPositionMax >= parentMax) {
					var fixedPosition = parentMax - sidebarHeight;
				}

				// as scroll is less than fixed offset
			} else {
				var fixedPosition = 0;
			}

			if (typeof fixedHeight === 'undefined') {
				$(".fixed-element").addClass(fixedClass).css('top', fixedPosition);
			} else {
				$(".fixed-element").addClass('transition');
				$(".fixed-element").addClass(fixedClass).css('top', fixedPosition);
			}

			// Console info
			// if (g_dev == true) {
			//console.log('[sidebarHeight:'+sidebarHeight+'] [g_windowHeight:'+g_windowHeight+']');
			//console.log('[scroll:'+scroll+'] [offsetTop:'+offsetTop+'] [offsetBottom:'+offsetBottom+']');
			// }

		} else {
			// Copy width
			$(".fixed-element").css('width', 'auto');
			$(".fixed-element").removeClass("fixed").removeClass("bottom");
		}

		// remove transition class after animation
		setTimeout(function () {
			$(".fixed-element").removeClass('transition');
		}, 500);

	}
}

var scrollParent = $(".fixed-row").outerHeight();
var sidebarParent = $(".fixed-element").parent();
var sidebarHeight = Math.round($(".fixed-element").outerHeight());
var contentHeight = Math.round($(".fixed-row .content").outerHeight());

$(document).ready(function () {
    fixedSidebar();
});

$(window).scroll(function() {
    fixedSidebar();
});

$(window).resize(function() {
    fixedSidebar();
});


// MobileMenu
// Adds a Mobile menu
$(document).ready(function () {

	$("body").on('click', '.btn-mobile-menu', function (e) {
		e.preventDefault();
		e.stopPropagation();
		$('body').addClass('open-menu');
		$(".header-menu > ul").clone().appendTo("#mobile-menu");
		$(".header-top-menu > ul").clone().appendTo("#mobile-menu");
	});

	// Toggle overlay
	$('body').on('click', '#mobile-overlay', function (e) {
		e.preventDefault();
		$('#mobile-menu').empty();
		$('body.open-menu').removeClass('open-menu');
	});

	mobileMenu();
	$(window).resize(mobileMenu);

	function mobileMenu() {
		var headerWidth = $('.header-section .wrapper').width() - $('.header-section .logo').outerWidth() - 20;
        var menuWidth = $('.header-info').outerWidth() + 100;

        if($('.header-menu .menu-item__contact').length) {
            menuWidth = $('.header-info').outerWidth();
        }

		if (menuWidth >= headerWidth) {
			$(".header-info").addClass('hiddenmenu');
			$(".btn-mobile-menu").show();
		} else {
			$(".header-info").removeClass('hiddenmenu');
			$(".btn-mobile-menu").hide();
		}
	}

});

$(document).on("click",".toggle-sub-menu", function(){
    $(this).toggleClass('active');
    $(this).siblings('.sub-menu').toggleClass('open');
});


$(document).ready(equalHeight);
$(window).load(equalHeight);
$(window).resize(equalHeight);
function equalHeight() {
	var groups = {};
    var groupNr = false;
    var groupUnset = false;
    var groupBreak = false;
    var groupBreakNr = false;
    // generate groups by their groupId set by elements using equal-group
    $('[equal-group]').each(function() {
		// console.log($(this).attr('equal-group'));
        var $this = $(this),
            groupId = $this.attr('equal-group');
        if (groupId in groups) {
            groups[groupId] = groups[groupId].add($this);
        } else {
            groups[groupId] = $this;
        }
    });
    // apply minHeight to each group
    $.each(groups, function() {
		groupNr = $(this).attr('equal-group-nr');
		groupUnset = $(this).attr('equal-group-unset');
		groupBreak = $(this).attr('equal-group-break');
		groupBreakNr = $(this).attr('equal-group-break-nr');
		if(groupNr!=undefined) {
			// console.log(groupNr);
			$(this).css('height','').setMinHeight(parseInt(groupNr));
		} else {
			$(this).css('height','').setMinHeight(0);
		}
		if(groupBreak!=undefined) {
			if (g_windowWidth <= groupBreak && groupBreakNr!=undefined) {
				$(this).css('height','').setMinHeight(parseInt(groupBreakNr));
			}
		}
		if(groupUnset!=undefined) {
			if (g_windowWidth <= groupUnset) {
				$(this).css('height','');
			}
		}
	});
}
$.fn.setMinHeight = function(setCount) {
    if (setCount == 0) {
        setCount = this.length;
    }
    for(var i = 0; i < this.length; i+=setCount) {
		var curSet = this.slice(i, i+setCount),
			height = 0;
		curSet.each(function() { height = Math.max(height, $(this).outerHeight()); })
			.outerHeight(height);
    }
    return this;
};


// ResponsiveTable
// Add a fixed column on a responsive-table
$(document).ready(function () {
	var $table = $('.responsive-table table');
	var $fixedColumn = $table.clone().insertBefore($table).removeClass('basis-table').addClass('fixed-column');
	$fixedColumn.find('th:not(:first-child),td:not(:first-child)').remove();
	setTableHeight();

	function setTableHeight() {
		$('div.responsive-table').each(function () {
			var div = $(this);
			$('table.basis-table tbody tr', div).each(function (i, el) {
				var hgt = $(this).outerHeight();
				$('table.fixed-column tr', div).eq(i).height(hgt);
				$('table.basis-table tbody tr', div).eq(i).height(hgt);
			});
			$('table tbody tr th', div).each(function (i, el) {
				var hgt = $(this).outerWidth();
				$('table.fixed-column', div).eq(i).width(hgt);
			});
		});
	}
});


// Fancybox - Desktop
// Shows content in fancybox on screens below 960px
$(document).ready(function () {
	fancyboxDesktop();
	$(window).load(fancyboxDesktop);
	$(window).resize(fancyboxDesktop);

	function fancyboxDesktop() {
		if(g_windowWidth < 960) {
			$('.fancybox-desktop').each(function() {
				$(this).removeClass('fancybox')
			});
            // Don't use lightbox template
            // var url = $(this).attr('href');
            // url = url.replace('?lightbox=1', '');
            // $(this).attr('href', url);
		} else {
            $('.fancybox-desktop').each(function() {
                $(this).addClass('fancybox');
            });
			// Use lightbox template
			// var url = $(".fancybox-desktop").attr("href");
			// $(".fancybox-desktop").attr("href", url + '?lightbox=1');
		}
	}
});


// Stappenplan
// Adds the vertical arrows depending on screen width
$(document).ready(function () {
	stappenPlan();
	$(window).load(stappenPlan);
	$(window).resize(stappenPlan);

	function stappenPlan() {
		var stappenSize = $('.stap-item').outerHeight() + 30;

		if (g_windowWidth >= 1440) {
			$('.arrow.up-down').remove();
			$('.stap-item:nth-child(5)').append('<div class="arrow up-down down-right"><div class="left"></div><div class="right"></div></div>');
			$('.arrow.up-down').height(stappenSize);
		} else if (g_windowWidth >= 960) {
			$('.arrow.up-down').remove();
			$('.stap-item:nth-child(4)').append('<div class="arrow up-down down-right"><div class="left"></div><div class="right"></div></div>');
			$('.stap-item:nth-child(8)').append('<div class="arrow up-down down-left"><div class="left"></div><div class="right"></div></div>');
			$('.arrow.up-down').height(stappenSize);
		} else if (g_windowWidth >= 800) {
			$('.arrow.up-down').remove();
			$('.stap-item:nth-child(3)').append('<div class="arrow up-down down-right"><div class="left"></div><div class="right"></div></div>');
			$('.stap-item:nth-child(6)').append('<div class="arrow up-down down-left"><div class="left"></div><div class="right"></div></div>');
			$('.stap-item:nth-child(9)').append('<div class="arrow up-down down-right"><div class="left"></div><div class="right"></div></div>');
			$('.arrow.up-down').height(stappenSize);
		} else if (g_windowWidth >= 640) {
			$('.arrow.up-down').remove();
			$('.stap-item:nth-child(2)').append('<div class="arrow up-down down-right"><div class="left"></div><div class="right"></div></div>');
			$('.stap-item:nth-child(4)').append('<div class="arrow up-down down-left"><div class="left"></div><div class="right"></div></div>');
			$('.stap-item:nth-child(6)').append('<div class="arrow up-down down-right"><div class="left"></div><div class="right"></div></div>');
			$('.stap-item:nth-child(8)').append('<div class="arrow up-down down-left"><div class="left"></div><div class="right"></div></div>');
			$('.arrow.up-down').height(stappenSize);
		}
	}
});


// fancybox confirm
function confirm(msg, msgOk, msgCancel, callBackOk, callBackCancel) {

	var msgOkHtml = '';
	var msgCancelHtml = '';

	// set messages
	if (msgOk != '') {
		msgOkHtml = '<div class="btn btn-success btn-lg fancy-confirm-btn" id="confirm-continu">' + msgOk + '</div>';
	}
	if (msgCancel != '') {
		msgCancelHtml = '<div class="btn btn-default btn-lg fancy-confirm-btn" id="confirm-cancel">' + msgCancel + '</div>';
	}

	$.fancybox({
		'modal': false,
		'content': '<div class="fancy-confirm-msg" style="min-width: 300px;">' + msg + '</div><div class="fancy-confirm-btns row">' + msgCancelHtml + '' + msgOkHtml + '</div>',
		'beforeShow': function () {
			$("#confirm-cancel").click(function () {
				$.fancybox.close();
				if (callBackCancel) {
					callBackCancel();
				}
			});
			$("#confirm-continu").click(function () {
				$.fancybox.close();
				if (callBackOk) {
					callBackOk();
				}
			});
		}
	});
}


$('body').on('click','#accessory-row .icon-info-with-circle',function() {

	if ($(this).closest('#accessory-row').find('#accessory-text').hasClass('hide')) {
		$(this).closest('#accessory-row').find('#accessory-text').removeClass('hide');
	} else {
		$(this).closest('#accessory-row').find('#accessory-text').addClass('hide');
	}
});
